// assets/user-reviews.js
(function () {
  "use strict";

  const section = document.getElementById("user-reviews-section");
  if (!section) return;

  const PRODUCT_ID = section.dataset.productId;
  const BACKEND_URL = window.__reviewsBackendUrl || "";

  // ── Star Selector ─────────────────────────────────────────────────
  const stars = document.querySelectorAll(".star-selector .star");
  const ratingInput = document.getElementById("rating-input");
  const ratingError = document.getElementById("rating-error");
  let currentRating = 0;

  function setRating(value) {
    currentRating = value;
    ratingInput.value = value;
    stars.forEach((star, index) => {
      star.textContent = index < value ? "★" : "☆";
      star.classList.toggle("active", index < value);
    });
    if (ratingError) ratingError.style.display = "none";
  }

  stars.forEach((star) => {
    star.addEventListener("mouseenter", () => {
      const val = parseInt(star.dataset.value);
      stars.forEach((s, i) => { s.textContent = i < val ? "★" : "☆"; });
    });
    star.addEventListener("mouseleave", () => {
      stars.forEach((s, i) => { s.textContent = i < currentRating ? "★" : "☆"; });
    });
    star.addEventListener("click", () => setRating(parseInt(star.dataset.value)));
    star.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setRating(parseInt(star.dataset.value));
      }
    });
  });

  // ── Character Counter ─────────────────────────────────────────────
  const bodyTextarea = document.getElementById("review-body");
  const charCount = document.getElementById("body-char-count");
  if (bodyTextarea && charCount) {
    bodyTextarea.addEventListener("input", () => {
      charCount.textContent = bodyTextarea.value.length;
    });
  }

  // ── Fetch Reviews (via Backend Proxy) ─────────────────────────────
  // Uses backend Admin API proxy for precise per-product filtering.
  // Storefront API does NOT support filtering metaobjects by field value.
  async function fetchReviews(productId) {
    const response = await fetch(
      `${BACKEND_URL}/api/reviews/product/${productId}?first=50&status=ACTIVE`
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch reviews: ${response.status}`);
    }

    const data = await response.json();
    const reviews = (data.reviews || []).map((r) => {
      // Process image references
      if (r.images_refs && r.images_refs.length > 0) {
        r.images_list = r.images_refs
          .filter((ref) => ref.image)
          .map((ref) => ref.image);
      }
      return r;
    });

    // Sort by created_at descending
    return reviews.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  }

  // ── Render Reviews ────────────────────────────────────────────────
  function renderStars(rating) {
    const num = Math.min(Math.max(parseInt(rating) || 0, 0), 5);
    return "★".repeat(num) + "☆".repeat(5 - num);
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function formatDate(isoStr) {
    if (!isoStr) return "";
    return new Date(isoStr).toLocaleDateString("en-US", {
      year: "numeric", month: "long", day: "numeric",
    });
  }

  function renderReviews(reviews, container) {
    if (reviews.length === 0) {
      container.innerHTML = `<p class="user-reviews-empty">No reviews yet. Be the first to share your experience!</p>`;
      return;
    }

    const avg = (
      reviews.reduce((sum, r) => sum + (parseInt(r.rating) || 0), 0) / reviews.length
    ).toFixed(1);

    const listHTML = reviews.map((r) => {
      const imagesHTML = (r.images_list || [])
        .map((img) => `<img src="${escapeHtml(img.url)}" alt="${escapeHtml(img.altText || '')}" width="${img.width}" height="${img.height}" class="ur-review-image" loading="lazy" />`)
        .join("");

      return `
        <div class="ur-review-item">
          <div class="ur-review-header">
            <span class="ur-stars" aria-label="${escapeHtml(r.rating)} star rating">${renderStars(r.rating)}</span>
            <strong class="ur-review-author">${escapeHtml(r.author_name || "Anonymous")}</strong>
            <span class="ur-review-date">${formatDate(r.created_at)}</span>
            ${r.verified_purchase === "true" ? '<span class="ur-verified-badge">✓ Verified Purchase</span>' : ""}
          </div>
          ${r.title ? `<h4 class="ur-review-title">${escapeHtml(r.title)}</h4>` : ""}
          <p class="ur-review-body">${escapeHtml(r.body || "")}</p>
          ${imagesHTML ? `<div class="ur-review-images">${imagesHTML}</div>` : ""}
        </div>
      `;
    }).join("");

    container.innerHTML = `
      <div class="ur-reviews-summary">
        <span class="ur-avg-rating">${avg}</span>
        <span class="ur-stars">${renderStars(Math.round(parseFloat(avg)))}</span>
        <span class="ur-count">${reviews.length} review${reviews.length !== 1 ? "s" : ""}</span>
      </div>
      <div class="ur-reviews-list">${listHTML}</div>
    `;
  }

  // ── Form Submit ───────────────────────────────────────────────────
  const form = document.getElementById("review-form");
  const statusEl = document.getElementById("review-status");
  const submitBtn = document.getElementById("submit-review-btn");

  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      if (!currentRating) {
        if (ratingError) ratingError.style.display = "block";
        return;
      }

      submitBtn.disabled = true;

      try {
        // 1. Upload images (if any)
        const imageFiles = document.getElementById("review-images")?.files;
        let imageGids = [];
        if (imageFiles && imageFiles.length > 0) {
          statusEl.textContent = "Uploading images...";
          imageGids = await window.uploadReviewImages(
            Array.from(imageFiles).slice(0, 5),
            BACKEND_URL
          );
        }

        // 2. Submit review
        statusEl.textContent = "Submitting...";
        const payload = {
          productId: form.dataset.productId,
          authorName: form.authorName.value.trim(),
          rating: currentRating,
          title: (form.title?.value || "").trim(),
          body: form.body.value.trim(),
          imageGids,
          orderId: new URLSearchParams(location.search).get("order") || null,
        };

        const res = await fetch(`${BACKEND_URL}/api/reviews`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (data.success) {
          statusEl.textContent = "Thank you for your review! It will appear after approval.";
          form.reset();
          setRating(0);
          const preview = document.getElementById("image-preview");
          if (preview) preview.innerHTML = "";
          if (charCount) charCount.textContent = "0";
        } else {
          statusEl.textContent = `Error: ${Array.isArray(data.error) ? data.error.map(e => e.message).join("; ") : data.error || "Submission failed"}`;
        }
      } catch (err) {
        console.error("Submit error:", err);
        statusEl.textContent = "Network error. Please try again.";
      } finally {
        submitBtn.disabled = false;
      }
    });
  }

  // ── URL Parameter Detection (invite email auto-scroll) ────────────
  if (new URLSearchParams(location.search).get("review") === "1") {
    const wrapper = document.getElementById("review-form-wrapper");
    if (wrapper) {
      setTimeout(() => wrapper.scrollIntoView({ behavior: "smooth", block: "center" }), 500);
    }
  }

  // ── Init: Load Reviews ────────────────────────────────────────────
  const reviewsContainer = document.getElementById("user-reviews-list");
  if (reviewsContainer && PRODUCT_ID) {
    fetchReviews(PRODUCT_ID)
      .then((reviews) => renderReviews(reviews, reviewsContainer))
      .catch(() => {
        reviewsContainer.innerHTML = "<p>Failed to load reviews. Please refresh.</p>";
      });
  }
})();
